// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__XkGLH","code":"NotFoundPage_code__6CLCG","message":"NotFoundPage_message__OiRsn","homeLink":"NotFoundPage_homeLink__+2NhS"};